function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Streaming-Delivery_hover",
  transform: "translate(-229.000000, -132.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-33",
  transform: "translate(229.000000, 132.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#623E93",
  cx: 24,
  cy: 24,
  r: 24
}), /*#__PURE__*/React.createElement("g", {
  id: "noun_Eye_585509",
  transform: "translate(14.000000, 19.000000)",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.88764045,0.0813057143 C5.86681079,0.0813057143 2.29918629,2.09593102 0.0842696629,5.20247918 C-0.0293605119,5.35949417 -0.0293605119,5.57161216 0.0842696629,5.72862714 C2.29918584,8.83522918 5.86681124,10.8568159 9.88764045,10.8568159 C13.9084694,10.8568159 17.4760948,8.83522918 19.6910112,5.72862714 C19.8046414,5.57161216 19.8046414,5.35949417 19.6910112,5.20247918 C17.4760946,2.09593102 13.9084699,0.0813057143 9.88764045,0.0813057143 Z M9.88764045,0.979264898 C13.4898906,0.979264898 16.6825517,2.73771367 18.75,5.46906082 C16.6824703,8.19858735 13.4884573,9.95885673 9.88764045,9.95885673 C6.28682337,9.95885673 3.09281034,8.19858735 1.0252809,5.46906082 C3.09272899,2.73771367 6.28539011,0.979264898 9.88764045,0.979264898 Z M9.88764045,2.32620367 C8.15543865,2.32620367 6.74157303,3.73862163 6.74157303,5.46906082 C6.74157303,7.19949551 8.15543865,8.61191796 9.88764045,8.61191796 C11.6198422,8.61191796 13.0337079,7.19949551 13.0337079,5.46906082 C13.0337079,3.73862163 11.6198422,2.32620367 9.88764045,2.32620367 Z M9.88764045,3.22416286 C11.1340533,3.22416286 12.1348315,4.22391469 12.1348315,5.46906082 C12.1348315,6.71419347 11.1340533,7.71395878 9.88764045,7.71395878 C8.64122764,7.71395878 7.64044944,6.71419347 7.64044944,5.46906082 C7.64044944,4.22391469 8.64122764,3.22416286 9.88764045,3.22416286 Z",
  id: "Shape"
}))))));
function SvgImpressions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImpressions);
export default __webpack_public_path__ + "static/media/impressions.863a718d102412d6b273f6eebe3711c7.svg";
export { ForwardRef as ReactComponent };